import { useQuery } from "react-query";
import TicketPurchasesAPI from "api/ticketPurchase";
import { TOURNAMENT_TICKET_PURCHASES } from "helpers/constants";

export default function useTournamentTicketPurchases(tournamentId) {
  return useQuery([TOURNAMENT_TICKET_PURCHASES, tournamentId], () =>
    TicketPurchasesAPI.getAllForTournament(tournamentId)
  );
}
